const basePath = "server/";

export const server = {
  id: 1,
  category: "Servers",

  filters: {
    Brand: { type: "checkbox" },
    Model: { type: "checkbox" },
    FormFactor: { type: "checkbox" },
    CPU: { type: "checkbox" },
    Sockets: { type: "checkbox" },
    RAM: { type: "checkbox" },
    "Storage Bays": { type: "checkbox" },
    "Power Supply": { type: "checkbox" },
    Network: { type: "checkbox" },
  },

  subcategories: [
    // ==========================
    // HPE SERVERS
    // ==========================
    {
      name: "HPE ProLiant DL360 Gen8",
      bestSeller: false,
      image: `${basePath}HPE_ProLiant_DL360_Gen8.png`,
      details: {
        Brand: "HPE",
        Model: "ProLiant DL360 Gen8",
        FormFactor: "1U Rack Server",
        CPU: "Intel Xeon E5-2600 v2",
        Sockets: "2",
        RAM: "Up to 768 GB DDR3",
        "Storage Bays": "8x SFF",
        "Power Supply": "500W/800W (Redundant)",
        Network: "4x 1Gb Ethernet",
      },
      about: `
        <ul>
          <li>Widely used 1U dual‑socket server from the early 2010s.</li>
          <li>Good balance of compute and memory capacity for virtualization.</li>
        </ul>
      `,
    },
    {
      name: "HPE ProLiant DL360 Gen9",
      bestSeller: false,
      image: `${basePath}HPE_ProLiant_DL360_Gen9.png`,
      details: {
        Brand: "HPE",
        Model: "ProLiant DL360 Gen9",
        FormFactor: "1U Rack Server",
        CPU: "Intel Xeon E5-2600 v3/v4",
        Sockets: "2",
        RAM: "Up to 1.5 TB DDR4",
        "Storage Bays": "8x SFF or 4x LFF",
        "Power Supply": "500W/800W (Redundant)",
        Network: "4x 1Gb Ethernet",
      },
      about: `
        <ul>
          <li>Enhanced performance with newer Xeon generations and DDR4 memory.</li>
          <li>Popular in enterprise virtualization, databases, and general compute workloads.</li>
        </ul>
      `,
    },
    {
      name: "HPE ProLiant DL360 Gen10",
      bestSeller: false,
      image: `${basePath}HPE_ProLiant_DL360_Gen10.png`,
      details: {
        Brand: "HPE",
        Model: "ProLiant DL360 Gen10",
        FormFactor: "1U Rack Server",
        CPU: "Intel Xeon Scalable (Skylake/Ice Lake)",
        Sockets: "2",
        RAM: "Up to 3 TB DDR4",
        "Storage Bays": "8x SFF or NVMe",
        "Power Supply": "500W/800W (Redundant)",
        Network: "4x 1Gb + optional 10Gb",
      },
      about: `
        <ul>
          <li>Modern 1U server designed for cloud, virtualization, and general compute.</li>
          <li>Support for NVMe boot, high-speed I/O, and advanced management.</li>
        </ul>
      `,
    },
    {
      name: "HPE ProLiant DL360 Gen11",
      bestSeller: false,
      image: `${basePath}HPE_ProLiant_DL360_Gen11.png`,
      details: {
        Brand: "HPE",
        Model: "ProLiant DL360 Gen11",
        FormFactor: "1U Rack Server",
        CPU: "Intel Xeon Scalable 4th Gen or AMD EPYC 9004",
        Sockets: "2",
        RAM: "Very high (e.g. DDR5 support)",
        "Storage Bays": "NVMe/SAS/SATA",
        "Power Supply": "Redundant options",
        Network: "1/10/25/100Gb options",
      },
      about: `
        <ul>
          <li>The latest generation 1U server with cutting-edge CPU and memory support.</li>
          <li>Optimized for AI, cloud-native workloads, and data-intensive applications.</li>
        </ul>
      `,
    },
    {
      name: "HPE ProLiant DL380 Gen8",
      bestSeller: false,
      image: `${basePath}HPE_ProLiant_DL380_Gen8.png`,
      details: {
        Brand: "HPE",
        Model: "ProLiant DL380 Gen8",
        FormFactor: "2U Rack Server",
        CPU: "Intel Xeon E5‑2600 v2",
        Sockets: "2",
        RAM: "Up to 768 GB DDR3",
        "Storage Bays": "12x SFF / 8x LFF",
        "Power Supply": "500W/900W (Redundant)",
        Network: "4x 1Gb Ethernet",
      },
      about: `
        <ul>
          <li>Reliable 2U performance for business-critical workloads since early 2010s.</li>
        </ul>
      `,
    },
    {
      name: "HPE ProLiant DL380 Gen9",
      bestSeller: false,
      image: `${basePath}HPE_ProLiant_DL380_Gen8.png`,
      details: {
        Brand: "HPE",
        Model: "ProLiant DL380 Gen9",
        FormFactor: "2U Rack Server",
        CPU: "Intel Xeon E5‑2600 v3/v4",
        Sockets: "2",
        RAM: "Up to 1.5 TB DDR4",
        "Storage Bays": "12x SFF / 8x LFF / NVMe options",
        "Power Supply": "500W/800W (Redundant)",
        Network: "4x 1Gb Ethernet",
      },
      about: `
        <ul>
          <li>Very popular in data centres for virtualization and big‑data workloads.</li>
        </ul>
      `,
    },

    // ==========================
    // DELL SERVERS
    // ==========================
    {
      name: "Dell PowerEdge R620",
      bestSeller: false,
      image: `${basePath}Dell_PowerEdge_R620.png`,
      details: {
        Brand: "Dell",
        Model: "PowerEdge R620",
        FormFactor: "1U Rack Server",
        CPU: "Intel Xeon E5‑2600 v2/v3",
        Sockets: "2",
        RAM: "Up to 768 GB DDR3/DDR4",
        "Storage Bays": "10x SFF",
        "Power Supply": "495W/750W (Redundant)",
        Network: "4x 1Gb Ethernet",
      },
      about: `
        <ul>
          <li>High-density 1U server used widely for virtualization.</li>
        </ul>
      `,
    },
    {
      name: "Dell PowerEdge R720",
      bestSeller: false,
      image: `${basePath}Dell_PowerEdge_R720.png`,
      details: {
        Brand: "Dell",
        Model: "PowerEdge R720",
        FormFactor: "2U Rack Server",
        CPU: "Intel Xeon E5‑2600 v2/v3",
        Sockets: "2",
        RAM: "Up to 768 GB DDR3/DDR4",
        "Storage Bays": "16x SFF or 8x LFF",
        "Power Supply": "750W/1100W (Redundant)",
        Network: "4x 1Gb",
      },
      about: `
        <ul>
          <li>A classic 2U server used in many enterprise deployments.</li>
        </ul>
      `,
    },
    {
      name: "Dell PowerEdge R730",
      bestSeller: false,
      image: `${basePath}Dell_PowerEdge_R730.png`,
      details: {
        Brand: "Dell",
        Model: "PowerEdge R730",
        FormFactor: "2U Rack Server",
        CPU: "Intel Xeon E5‑2600 v4",
        Sockets: "2",
        RAM: "Up to 1.5 TB DDR4",
        "Storage Bays": "16x SFF / 8x LFF / NVMe",
        "Power Supply": "750W/1100W (Redundant)",
        Network: "4x 1Gb or 10Gb options",
      },
      about: `
        <ul>
          <li>Versatile server for virtualization, database, and web workloads.</li>
        </ul>
      `,
    },
    {
      name: "Dell PowerEdge R740",
      bestSeller: true,
      image: `${basePath}Dell_PowerEdge_R740.png`,
      details: {
        Brand: "Dell",
        Model: "PowerEdge R740",
        FormFactor: "2U Rack Server",
        CPU: "Intel Xeon Scalable (Skylake/Cascade Lake)",
        Sockets: "2",
        RAM: "Up to 3 TB DDR4",
        "Storage Bays": "Up to 16x NVMe/SAS/SATA",
        "Power Supply": "750W/1100W (Redundant)",
        Network: "10Gb options",
      },
      about: `
        <ul>
          <li>Modern 2U platform optimized for software‑defined storage and virtualized systems.</li>
        </ul>
      `,
    },
    {
      name: "Dell PowerEdge R750",
      bestSeller: false,
      image: `${basePath}Dell_PowerEdge_R750.png`,
      details: {
        Brand: "Dell",
        Model: "PowerEdge R750",
        FormFactor: "2U Rack Server",
        CPU: "3rd / 4th Gen Intel Xeon Scalable",
        Sockets: "2",
        RAM: "Up to 4 TB DDR4/DDR5 (depending on gen)",
        "Storage Bays": "NVMe/SAS/SATA options",
        "Power Supply": "750W/1100W+ (Redundant)",
        Network: "10Gb / 25Gb options",
      },
      about: `
        <ul>
          <li>Next‑generation Dell server for AI, enterprise databases, and cloud workloads.</li>
        </ul>
      `,
    },
    {
      name: "Dell PowerEdge R770",
      bestSeller: false,
      image: `${basePath}Dell_PowerEdge_R770.png`,
      details: {
        Brand: "Dell",
        Model: "PowerEdge R770",
        FormFactor: "2U Rack Server",
        CPU: "4th Gen Intel Xeon Scalable (Sapphire Rapids)",
        Sockets: "2",
        RAM: "Very high DDR5 capacity",
        "Storage Bays": "Extensive NVMe / SAS capability",
        "Power Supply": "Redundant high wattage",
        Network: "25/100Gb options",
      },
      about: `
        <ul>
          <li>A very high‑performance 2U server built for modern cloud and data-intensive applications.</li>
        </ul>
      `,
    },

    // ==========================
    // LENOVO SERVERS
    // ==========================
    {
      name: "Lenovo ThinkSystem SR630",
      bestSeller: false,
      image: `${basePath}Lenovo_ThinkSystem_SR630.png`,
      details: {
        Brand: "Lenovo",
        Model: "ThinkSystem SR630",
        FormFactor: "1U Rack Server",
        CPU: "Intel Xeon Scalable",
        Sockets: "2",
        RAM: "Up to 1.5 TB DDR4",
        "Storage Bays": "Up to 10x SFF / NVMe",
        "Power Supply": "550W/750W (Redundant)",
        Network: "1/10Gb options",
      },
      about: `
        <ul>
          <li>A compact 1U server from Lenovo’s ThinkSystem line for virtualization and general workloads.</li>
        </ul>
      `,
    },
    {
      name: "Lenovo ThinkSystem SR650",
      bestSeller: true,
      image: `${basePath}Lenovo_ThinkSystem_SR650.png`,
      details: {
        Brand: "Lenovo",
        Model: "ThinkSystem SR650",
        FormFactor: "2U Rack Server",
        CPU: "Intel Xeon Scalable",
        Sockets: "2",
        RAM: "Up to 4 TB DDR4",
        "Storage Bays": "24x SFF or combination with NVMe",
        "Power Supply": "750W/1100W (Redundant)",
        Network: "1/10/25Gb options",
      },
      about: `
        <ul>
          <li>One of Lenovo’s most popular rack servers — very flexible and widely used.</li>
        </ul>
      `,
    },
    {
      name: "Lenovo ThinkSystem SR850",
      bestSeller: false,
      image: `${basePath}Lenovo_ThinkSystem_SR850.png`,
      details: {
        Brand: "Lenovo",
        Model: "ThinkSystem SR850",
        FormFactor: "2U Rack Server",
        CPU: "Up to 4 Intel Xeon Scalable",
        Sockets: "4",
        RAM: "Up to 12 TB DDR4",
        "Storage Bays": "24x hot-swap / NVMe options",
        "Power Supply": "1100W/1600W (Redundant)",
        Network: "10/25/100Gb",
      },
      about: `
        <ul>
          <li>High‑memory, multi-socket server for enterprise-scale databases and in-memory workloads.</li>
        </ul>
      `,
    },

    // ==========================
    // SUPERMICRO SERVERS
    // ==========================
    {
      name: "Supermicro SuperServer 1029U",
      bestSeller: false,
      image: `${basePath}Supermicro_SuperServer_1029U.svg`,
      details: {
        Brand: "Supermicro",
        Model: "SuperServer 1029U",
        FormFactor: "1U Rack Server",
        CPU: "Intel Xeon Scalable (various gens)",
        Sockets: "2",
        RAM: "Up to 4 TB DDR4 / DDR5 (depending on board)",
        "Storage Bays": "8x SFF or NVMe",
        "Power Supply": "800W/1200W Redundant",
        Network: "Dual 10Gb or 1Gb",
      },
      about: `
        <ul>
          <li>High-density 1U server suitable for virtualization, compute, and storage.</li>
        </ul>
      `,
    },
    {
      name: "Supermicro SuperServer 2029U",
      bestSeller: false,
      image: `${basePath}Supermicro_SuperServer_2029U.svg`,
      details: {
        Brand: "Supermicro",
        Model: "SuperServer 2029U",
        FormFactor: "1U Rack Server",
        CPU: "AMD EPYC / Intel Xeon",
        Sockets: "2",
        RAM: "High capacity DDR4/DDR5 depending on board",
        "Storage Bays": "NVMe-optimized or SATA",
        "Power Supply": "Redundant high efficiency",
        Network: "10/25Gb options",
      },
      about: `
        <ul>
          <li>Performance-oriented 1U server with options for latest AMD EPYC CPUs.</li>
        </ul>
      `,
    },
    {
      name: "Supermicro 4029GP‑TRT",
      bestSeller: false,
      image: `${basePath}Supermicro_4029GP‑TRT.png`,
      details: {
        Brand: "Supermicro",
        Model: "4029GP‑TRT",
        FormFactor: "4U GPU Server",
        CPU: "Dual Xeon Scalable / AMD EPYC",
        Sockets: "2",
        RAM: "Very high (256 GB+ depending)",
        "Storage Bays": "NVMe / SAS + GPU support",
        "Power Supply": "2000W+ Redundant",
        Network: "High‑speed network options",
      },
      about: `
        <ul>
          <li>GPU-optimized 4U server for AI, ML, HPC training.</li>
        </ul>
      `,
    },

    // ==========================
    // ASUS SERVERS
    // ==========================
    {
      name: "ASUS ESC8000 G4",
      bestSeller: false,
      image: `${basePath}ASUS_ESC8000_G4.png`,
      details: {
        Brand: "ASUS",
        Model: "ESC8000 G4",
        FormFactor: "4U Rack Server",
        CPU: "Intel Xeon Scalable",
        Sockets: "2",
        RAM: "High (supports large RDIMMs)",
        "Storage Bays": '12x 3.5" or mix',
        "Power Supply": "2000W Redundant",
        Network: "10/25Gb selectable",
      },
      about: `
        <ul>
          <li>Designed for GPU / AI / HPC workloads, supports multiple double‑wide GPUs.</li>
        </ul>
      `,
    },
    {
      name: "ASUS ESC4000 G4",
      bestSeller: false,
      image: `${basePath}ASUS_ESC4000_G4.png`,
      details: {
        Brand: "ASUS",
        Model: "ESC4000 G4",
        FormFactor: "2U Rack Server",
        CPU: "Intel Xeon Scalable",
        Sockets: "2",
        RAM: "Up to large capacity",
        "Storage Bays": "NVMe / SAS mix",
        "Power Supply": "1600W Redundant",
        Network: "High-speed network options",
      },
      about: `
        <ul>
          <li>Balanced 2U server for compute‑ and GPU-intensive tasks.</li>
        </ul>
      `,
    },

    // ==========================
    // IBM SERVERS
    // ==========================
    {
      name: "IBM Power System S822",
      bestSeller: false,
      image: `${basePath}IBM_Power_System_S822.svg`,
      details: {
        Brand: "IBM",
        Model: "Power System S822",
        FormFactor: "2U Rack Server",
        CPU: "IBM POWER8",
        Sockets: "2",
        RAM: "Very high capacity",
        "Storage Bays": "SAS / NVMe",
        "Power Supply": "Redundant",
        Network: "High speed IB / Ethernet",
      },
      about: `
        <ul>
          <li>POWER8-based system for enterprise, cloud, and analytics
        </ul>
      `,
    },
  ],
};
